'use client';

import React from 'react';
import styled from '@benzinga/themetron';

export interface SpinnerProps {
  text?: string;
  size?: number;
}

export const Spinner: React.FC<SpinnerProps> = ({ size, text }) => {
  const iconSize = size ?? 32;
  const compact = size != null;

  return (
    <Container $compact={compact} $size={iconSize} className="spinner">
      <div role="status">
        <svg
          aria-hidden="true"
          className="spinner-icon"
          fill="none"
          viewBox="0 0 100 101"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          ></path>
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          ></path>
        </svg>
        <span className="sr-only">Loading...</span>
      </div>
      {text && <span className="text-text">{text}</span>}
    </Container>
  );
};

export default Spinner;

const Container = styled.div<{ $size: number; $compact: boolean }>`
  &.spinner {
    flex: ${props => (props.$compact ? 'none' : 1)};
    display: flex;
    flex-direction: column;
    font-size: 25px;
    align-items: center;
    justify-content: center;
    color: ${props => (props.$compact ? 'inherit' : undefined)};
    .spinner-icon {
      color: transparent;
      fill: ${props => (props.$compact ? 'currentColor' : props.theme.colors.brand)};
      -webkit-animation: spin 1s linear infinite;
      animation: spin 1s linear infinite;
      width: ${props => props.$size}px;
      height: ${props => props.$size}px;
    }
    .text-text {
      font-size: ${({ theme }) => theme.fontSize.base};
      color: ${props => props.theme.colors.brand};
      margin-top: 0.5rem;
    }
    .sr-only {
      display: none;
    }

    @-moz-keyframes spin {
      0% {
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -moz-transform: rotate(359deg);
        -o-transform: rotate(359deg);
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
      }
    }
    @-webkit-keyframes spin {
      0% {
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -moz-transform: rotate(359deg);
        -o-transform: rotate(359deg);
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
      }
    }
    @-o-keyframes spin {
      0% {
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -moz-transform: rotate(359deg);
        -o-transform: rotate(359deg);
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
      }
    }
    @-ms-keyframes spin {
      0% {
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -moz-transform: rotate(359deg);
        -o-transform: rotate(359deg);
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
      }
    }
    @keyframes spin {
      0% {
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -moz-transform: rotate(359deg);
        -o-transform: rotate(359deg);
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
      }
    }
  }
`;
